import React from "react";
import Sidebar from "./Sidebar";

export default function Layout({ children, title, subtitle, action }) {
  return (
    <div className="flex min-h-screen bg-[#F9F8F6]">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <header className="px-10 py-8 border-b border-[#E6E4E0] bg-white flex items-end justify-between gap-6 fade-up">
          <div>
            {subtitle && <div className="label-tiny mb-2">{subtitle}</div>}
            <h1 className="text-3xl font-light tracking-tight" style={{ fontFamily: "Outfit" }}>{title}</h1>
          </div>
          {action && <div>{action}</div>}
        </header>
        <div className="p-10 fade-up">{children}</div>
      </main>
    </div>
  );
}
